import { cn } from "@/lib/utils";

interface SkeletonProps extends React.ComponentProps<"div"> {
  circle?: boolean; // Prop auxiliar para avatares
  shimmerDelay?: number; // Atraso (s) do brilho — usado para criar o efeito de onda
}

function Skeleton({ className, circle, shimmerDelay, ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        // Base: Fundo cinza e overflow hidden para conter o brilho
        "relative overflow-hidden bg-muted/60",
        // Formato: Se circle for true, usa rounded-full, senão rounded-md
        circle ? "rounded-full" : "rounded-md",
        className,
      )}
      {...props}
    >
      {/* O Brilho (Shimmer) */}
      <div
        style={shimmerDelay ? { animationDelay: `${shimmerDelay}s` } : undefined}
        className={cn(
          "absolute inset-0 -translate-x-full", // Começa fora da tela à esquerda
          "animate-shimmer", // Animação definida no tailwind.config
          // Gradiente: Transparente -> Branco suave -> Transparente
          "bg-gradient-to-r from-transparent via-foreground/15 to-transparent",
          // Ajuste para Dark Mode (brilho mais sutil)
          "dark:via-foreground/20",
        )}
      />
    </div>
  );
}

export { Skeleton };
